import _ from 'lodash'
import { PANEL_ENVS } from 'utils/constants/environments'
import { findArrayDuplicates } from 'utils/functions'
import { isDocNumberValid } from 'utils/validators'

const CPF_CHARS_REGEX = '0-9'
const CNPJ_CHARS_REGEX = 'A-Za-z0-9'

export const processText = (textArray, docType) => {
  const invalidDocs = []
  const validDocs = []

  let textArrayTreated = _.map(textArray, (x) => x.trim())
  textArrayTreated = _.reject(textArrayTreated, (x) => _.isEmpty(x))

  const zeroLeftSize = docType === PANEL_ENVS.CNPJ ? 14 : 11
  const regexChars = docType === PANEL_ENVS.CNPJ ? CNPJ_CHARS_REGEX : CPF_CHARS_REGEX

  textArrayTreated.forEach((docLine) => {
    if (new RegExp(`[^${regexChars}-./]`).test(docLine)) {
      invalidDocs.push(docLine)
      return
    }

    const docLineSanitized = docLine.replace(new RegExp(`[^${regexChars}]`, 'g'), '')
    const docToBeValidated = docLineSanitized.padStart(zeroLeftSize, '0')

    if (isDocNumberValid(docToBeValidated, docType)) {
      validDocs.push(docToBeValidated)
      return
    }

    invalidDocs.push(docLine)
  })

  const uniqueValidDocs = _.uniq(validDocs)

  return {
    validDocs: validDocs,
    invalidDocs: invalidDocs,
    docsDuplicates: findArrayDuplicates(validDocs),
    uniqueValidDocs: uniqueValidDocs,
    totalDocsProvided: validDocs.length + invalidDocs.length,
  }
}
